import React from "react";
import SEOHead from "../components/tools/SEOHead";
import MarketingShell, { Arrow, useMarketingCopy } from "./MarketingShell";
import DatedTimeline from "./DatedTimeline";
import narrative from "./siteNarrativeCopy.json";
import "./LandingJourney.css";
import "./CompanyNarrative.css";

export default function MissionPage() {
  const { language, routes } = useMarketingCopy();
  const copy = (narrative[language] ?? narrative.en).mission;
  return <MarketingShell active="mission" variant="voyage">
    <SEOHead title={`YouWo — ${routes.navMission}`} description={copy.description} canonicalUrl="https://youwo.ai/mission" ogImage="https://youwo.ai/brand/youwo-sky-ocean-v1.webp"
      structuredData={{ "@context": "https://schema.org", "@type": "AboutPage", name: `YouWo — ${routes.navMission}`, description: copy.description, url: "https://youwo.ai/mission" }} />
    <main id="main-content" tabIndex={-1} className="voyage-main company-mission">
      <section className="voyage-sky" aria-labelledby="mission-title">
        <div className="voyage-atmosphere" aria-hidden="true"><img src="/brand/youwo-sky-ocean-v1.webp" width="1536" height="1024" alt="" decoding="async" /></div>
        <div className="quant-wrap voyage-hero-copy"><p className="voyage-signature">YouWo — 由我</p><h1 id="mission-title">{copy.title}{" "}<br /><em>{copy.accent}</em></h1><p className="quant-lead">{copy.description}</p></div>
        <div className="quant-wrap voyage-horizon"><p>{copy.horizon}</p><a href="#milestones">{copy.roadmapLabel}<Arrow /></a></div>
      </section>
      <div className="voyage-depth">
        <section id="milestones" className="quant-wrap narrative-split" aria-labelledby="mission-roadmap-title">
          <div className="narrative-aside"><h2 id="mission-roadmap-title">{copy.roadmapTitle}</h2><p>{copy.roadmapDescription}</p><a className="quant-text-link" href="/story">{copy.storyLink}<Arrow /></a></div>
          <DatedTimeline entries={copy.milestones} label={copy.roadmapLabel} />
        </section>
        <section className="quant-wrap mission-commitments" aria-label={copy.commitmentLabel}><div>{copy.commitments.map(item => <article key={item.title}><h2>{item.title}</h2><p>{item.text}</p></article>)}</div></section>
        <section id="beliefs" className="quant-wrap narrative-split mission-beliefs" aria-labelledby="mission-beliefs-title">
          <div className="narrative-aside"><h2 id="mission-beliefs-title">{copy.beliefTitle}</h2></div>
          <ol className="belief-list">{copy.beliefs.map((item,index) => <li key={item.title}><span>0{index+1}</span><div><h3>{item.title}</h3><p>{item.text}</p></div></li>)}</ol>
        </section>
        <section id="story" className="quant-wrap narrative-invitation"><h2>{copy.closeTitle}</h2><a className="quant-text-link" href="/story#next-chapter">{copy.closeLink}<Arrow diagonal /></a></section>
      </div>
    </main>
  </MarketingShell>;
}
